export default __webpack_public_path__ + "static/media/icon-begin-assessment.d75ee495.svg";